import Vue from 'vue';
import { gsap } from 'gsap';

Vue.component('downloads-filter-component', {
    props: {
        loadMoreAmount: {
            type: Number,
            default: 6,
        },

        items: {
            type: Object,
            default: () => {},
        },
    },
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            currentIndex: 1,
            maxIndex: 1,
            noMoreItems: false,
            enabledCategories: 'all',
        };
    },

    computed: {
        formattedData() {
            const filteredItems = { ...this.items };

            for (let i = 0; i < Object.keys(this.items).length; i++) {
                const key = Object.keys(this.items)[i];

                const temp = this.items[key].filter((item) => {
                    if (item.mainCategory === this.enabledCategories || this.enabledCategories === 'all') {
                        return item;
                    }

                    return false;
                });

                filteredItems[key] = temp;
            }

            return filteredItems;
        },
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {},

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        setCategories(categoryId) {
            if (categoryId === this.enabledCategories) {
                return;
            }

            gsap.to('.downloads__main-container', {
                opacity: 0,
                duration: 0.8,
                ease: 'power4.out',
            });
            gsap.delayedCall(0.4, () => {
                this.enabledCategories = categoryId;
                this.setRevealedClass();
            });
        },
        setRevealedClass() {
            Vue.nextTick(() => {
                const allItems = document.querySelectorAll('.downloads__section');
                allItems.forEach((element) => {
                    element.classList.add('--revealed');
                });

                gsap.to('.downloads__main-container', {
                    opacity: 1,
                    delay: 0.4,
                    duration: 1,
                    ease: 'power4.out',
                });
            });
        },
    },
});
